export default __webpack_public_path__ + "static/media/1.39a4d3e1.jpg";